module.exports = __webpack_public_path__ + "img/labmemtest_title_jp.fcc6843f.png";